import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createGeneration,
  createImage,
  GenerationRequest,
  GenerationResponse,
  getGenerationStatus,
  ImageGenerationRequest,
  ImageGenerationResponse,
  StartGenerationResponse,
} from '../../services/generationsApi';

export const useCreateGeneration = () => {
  return useMutation<StartGenerationResponse, Error, GenerationRequest>({
    mutationFn: (data: GenerationRequest) => createGeneration(data),
  });
};

export const useGenerationStatus = (
  taskId: string | null,
  enabled: boolean = true,
  continueThroughLyricsReady: boolean = false,
  isRegeneratingLyrics: boolean = false,
) => {
  return useQuery<GenerationResponse, Error>({
    queryKey: ['generationStatus', taskId],
    queryFn: () => getGenerationStatus(taskId!),
    enabled: !!taskId && enabled,
    structuralSharing: false,
    refetchInterval: ({ state }) => {
      const status = state?.data?.status;
      //  polling if lyrics are being regenerated
      if (isRegeneratingLyrics) {
        return 5000;
      }
      // stop polling when completed, failed, or lyrics ready (workflow mode)
      if (
        status === 'completed' ||
        status === 'failed' ||
        (!continueThroughLyricsReady && status === 'lyrics_ready') ||
        state.error
      ) {
        return false;
      }
      // poll every 5 seconds
      return 5000;
    },
    retry: 3,
    retryDelay: 1000,
  });
};

export const useCreateImage = () => {
  return useMutation<ImageGenerationResponse, Error, ImageGenerationRequest>({
    mutationFn: (data: ImageGenerationRequest) => createImage(data),
  });
};
